import getApiInstance from 'data/common/ApiCallGenerique';
/** @var Logger Logger */
import Logger from 'data/common/Logger';
import api from './api';
/** @var ApiCall apiCaller */
const apiCaller = getApiInstance();

function getCommercialAgents() {
    return dispatch => {
        return apiCaller
            .call(api.getAllCommercialAgents())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'SIMULATIONENR__INIT_COMMERCIALAGENTS',
                        commercialAgents: data.commercialAgents
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setSimulationenrCommercialAgents - ', error);
                throw new Error('commercial_agents_have_not_been_correctly_returned_by_server');
            });
    };
}

function getCommercialAgentDetails(commercialAgentId) {
    return dispatch => {
        return apiCaller
            .call(api.getCommercialAgentsDetails(commercialAgentId))
            .then(({ data }) => {
                if (data.success) {
                    if (data.commercialAgentDetails) {
                        dispatch({
                            type: 'SIMULATIONENR__SET_COMMERCIALAGENTDETAILS',
                            commercialAgent: data.commercialAgentDetails
                        });
                    } else throw new Error('commercial_agent_details_have_not_been_correctly_returned_by_server');
                    if (data.projects) {
                        dispatch({
                            type: 'SIMULATIONENR__SET_PROJECTS',
                            projects: data.projects
                        });
                    } else throw new Error('projects_have_not_been_correctly_returned_by_server');
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setSimulationenrCommercialAgentDetails - ', error);
                throw error;
            });
    };
}

export { getCommercialAgents, getCommercialAgentDetails };



// WEBPACK FOOTER //
// ./environments/simulationenr/data/CommercialAgents/actions.js